import React from 'react'
import { use } from 'xadmin'
import { _t } from 'xadmin-i18n'
import _ from 'lodash'

const DetailView = props => {
  const { id } = props

  const { model } = use('model')

  const tableid = model?.tableid

  let mutiple = null

  if (location.pathname.indexOf('_p_') > 0) {
    mutiple = '/_p_' + location.pathname.split('_p_')[1]
  }

  return <iframe
    src={`/fullscreen${mutiple ? mutiple : ''}#/app/table/${tableid}/${id}/detail?loadwarning=false`}
    frameBorder="0"
    width={'100%'}
    height={'100%'}
    allowtransparency
  ></iframe>
}

export default DetailView
